import { Button, Dialog, DialogContent, DialogTitle, Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Box } from "@mui/system";
import { Field, Form } from "react-final-form";
import { useTranslation } from "react-i18next";
import CustomAlert from "../../components/CustomAlert";
import { SelectBoxComponent } from "../../components/CustomFormElement";
import validators from "../../utils/validators";

const useStyles = makeStyles((theme) => ({
    paperXs: {
        width: 500
    },
    paperSm: {
        width: 600
    },
    paperMd: {
        width: 900
    },
    paperLg: {
        width: 1000
    },
    paperXl: {
        width: 1200
    },
    button: {
        marginRight: theme.spacing(2),
    }
}));

export default function TerminateConfirm(props) {
    const classes = useStyles();
    const { t } = useTranslation();

    const { open, onClose, maxWidth, reasonSelected, listReason } = props;

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth={maxWidth ? maxWidth : 'sm'}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            classes={{
                paper: maxWidth === 'sm' ? classes.paperSm : classes.paperXs,
            }}
        >
            <DialogTitle id="alert-dialog-title">
                {t('confirm_terminate')}
            </DialogTitle>
            <DialogContent>
                <Form
                    onSubmit={props.onTerminate}
                    render={({ handleSubmit, reset, submitting, pristine, values }) => (
                        <Grid xs={12} container item justify="center" alignItems="center">
                            <Grid xs={12} item style={{ width: '100%' }}>
                                <Grid xs={12} item >
                                    <Field
                                        fullWidth
                                        name="reason_id"
                                        label={t('select_reason')}
                                        placeholder={t('select_reason')}
                                        component={SelectBoxComponent}
                                        validate={validators.composeValidators(validators.required)}
                                        options={listReason}
                                        itemValue='id'
                                        itemDisplay='reason'
                                        showNulValue={true}
                                        titleNullValue={t('select_reason')}
                                        value={reasonSelected ? reasonSelected.id : null}
                                    />
                                </Grid>
                                <Grid xs={12} item paddingTop={2} container justifyContent={"flex-end"}>
                                    <Button variant="contained" color="primary" onClick={handleSubmit} className={classes.button}>{t('btn_yes')}</Button>
                                    <Button variant="contained" color="primary" onClick={() => onClose()} className={classes.button}>{t('btn_cancel')}</Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    )}
                />
            </DialogContent>
        </Dialog>
    );
}